import React from 'react'
import "./SubStyle.css"

const Acc_Capital = () => {
  return (
    <section className="SubServices">
     <h1 className="SubServices-title">Capital Allowances</h1>
      <p className="SubServices-pera">Maximise the tax relief available on qualifying business assets and property investments. We identify eligible expenditure and help you claim the allowances you're entitled to, improving cash flow and reducing tax liabilities.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Acc_Capital
